module.exports = __webpack_public_path__ + "img/icon_t15_c.b1eca6d9.png";